import { render, staticRenderFns } from "./Editions.vue?vue&type=template&id=327b3c02"
import script from "./Editions.vue?vue&type=script&lang=js"
export * from "./Editions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports